import { Header } from '@trinity/chat-components/components/Modal/Header.js';
import { useModal } from '@trinity/chat-components/components/Modal/hooks/index.js';
import type { ModalProps } from '@trinity/chat-components/components/Modal/Modal.js';
import { Modal } from '@trinity/chat-components/components/Modal/Modal.js';
import { AddEntityForm } from './AddEntity.Form';
import styles from './style/AddEntity.Form.module.css';

type Props = {
  loading: boolean;
  onSubmit: (items: { name: string; type: string }[]) => void;
} & Pick<ModalProps, 'onClose' | 'open'>;

export const AddEntityModal = (props: Props) => {

  return (
    <Modal
      classes={{ root: styles.modal }}
      onClose={props.onClose}
      open={props.open}>
      <Header>Add Entity</Header>
      <AddEntityForm
        minEntries={1}
        loading={props.loading}
        onCancel={props.onClose}
        onSubmit={props.onSubmit} />
    </Modal>
  );
};

AddEntityModal.displayName = 'AddEntityModal';

export const useAddEntityModal = () => useModal(AddEntityModal);